import { render } from "./AdicionarPergunta.vue?vue&type=template&id=bd5b208c&scoped=true"
import script from "./AdicionarPergunta.vue?vue&type=script&lang=js"
export * from "./AdicionarPergunta.vue?vue&type=script&lang=js"

import "./AdicionarPergunta.vue?vue&type=style&index=0&id=bd5b208c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5b208c"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn});
